import { useAvContext } from '@context/AvContextProvider';
import { FeatureFlags } from '@fabric-ui/components';
import { useTags } from '@views/ContentPermissions/hooks';
import { useDashboardsList } from '../hooks';
import { ReportsTypes } from '../types';

export const useDashboardsTagsList = (type: ReportsTypes = ReportsTypes.Visual) => {
  const { featureFlags } = useAvContext();
  const isPaginated = !!featureFlags[FeatureFlags.DashboardReportsPaginated];

  const tagsQuery = useTags({ enabled: isPaginated });
  const { data: dashboards = [], ...dashboardsRest } = useDashboardsList(type, { enabled: !isPaginated });

  if (isPaginated) {
    const { data: tags = [], ...rest } = tagsQuery;
    return { ...rest, data: tags.map(tag => tag.name) };
  }

  return {
    ...dashboardsRest,
    data: [...new Set(dashboards.flatMap(dashboard => dashboard.tags || []))].filter(Boolean),
  };
};
